/**
 * Copyright (c) 2019 2020 2021 2022 AIGIA. All Rights Reserved.
 * see license.txt
 */

"use strict";

import {Component, HostListener, Inject, OnInit} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

import {Router} from "@angular/router";
import {TranslateService} from "@ngx-translate/core";

/**
 *
 *
 * @since 0.01
 */
@Component({
	selector: "aigia-policy-dialog",
	styleUrls: ["../aigia-auth.component.css"],
	templateUrl: "./aigia-policy-dialog.component.html",
})

export class AigiaPolicyDialogComponent {

	/**
	 * todo
	 */
	get lang(): any {
		return localStorage.getItem("language");
	}

	/**
	 * @constructor
	 * @param matDialogRef
	 * @param router
	 */
	constructor(
		@Inject(MAT_DIALOG_DATA)
		public matDialogRef: MatDialogRef<AigiaPolicyDialogComponent>,
		protected router: Router,
		public translate: TranslateService
	) {

	}

	public isEndScroll = false;


	/**
	 * @param value target value
	 * @param center range center
	 * @param width  range width
	 * @returns is in?
	 */
	private range(value: number, center: number, width: number): boolean {
		return (value >= (center - width)) && (value <= (center + width));
	}

	/**
	 * @returns none
	 */
	@HostListener('scroll', ['$event'])
	public onScroll($event: any): void {
		const element: any = $event.srcElement;
		const full_height: number = element.scrollHeight;
		const current: number = element.offsetHeight + element.scrollTop;
		this.isEndScroll = this.range(current, full_height, 20);
	}

	/**
	 * @returns none
	 */
	public cancel(): void {
		this.matDialogRef.close(false);
	}

	/**
	 * @returns none
	 */
	public accept(): void {
		this.matDialogRef.close(true);
	}

}
